import { z } from "zod";

import { ALL_CALCULATIONS } from "~/tools/calculate-value-from-points";
import { filter } from "~/tools/filter";
import { isPresent } from "~/tools/is-present";

import { WidgetLegend } from "../../../components/widget-form/legend/form-state";
import { WidgetThresholdsMode } from "../../../components/widget-form/thresholds/form-state";
import { dashboardWidgetFormatSchema } from "../_dashboard-widget-format";
import { dashboardWidgetThresholds } from "../_dashboard-widget-threshold";

const yAxis = z
	.object({
		show: z.boolean().optional().catch(undefined),
		label: z.string().trim().optional().catch(undefined),
		min: z.number().optional().catch(undefined),
		max: z.number().optional().catch(undefined),
		format: dashboardWidgetFormatSchema.optional().catch(undefined),
	})
	.optional()
	.catch(undefined);

const legend = z
	.object({
		show: z.boolean().optional().catch(undefined),
		position: z.enum(WidgetLegend.allPositions).optional().catch(undefined),
		mode: z.enum(WidgetLegend.allModes).optional().catch(undefined),
		values: z
			.array(z.enum(ALL_CALCULATIONS).optional().catch(undefined))
			.transform(filter(isPresent))
			.optional()
			.catch(undefined),
	})
	.optional()
	.catch(undefined);

type DashboardWidgetLegend = z.infer<typeof legend>;

const thresholds = z
	.object({
		mode: z.enum(WidgetThresholdsMode.all).optional().catch(undefined),
		steps: dashboardWidgetThresholds,
	})
	.optional()
	.catch(undefined);

export { yAxis, legend, thresholds };
export type { DashboardWidgetLegend };
